import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography, Box, CircularProgress } from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import { fetchRealtimeUsers } from '../../api/analyticsApi';
import { io } from 'socket.io-client';
const socket = io(process.env.REACT_APP_API_URL);

const RealtimeUsersCard = () => {
  const [count, setCount] = useState(null);

  useEffect(() => {
    const getRealtimeUsers = async () => {
      const user = JSON.parse(localStorage.getItem('user'));
      const count = await fetchRealtimeUsers(user?.propertyId?.id);
      setCount(count);
    };

    getRealtimeUsers();
    const interval = setInterval(getRealtimeUsers, 15000); // every 15 sec

    socket.on('realtimeUsers', (newCount) => {
      setCount(newCount);
    });

    return () => {
      clearInterval(interval);
      socket.off('realtimeUsers');
    };
  }, []);

  return (
    <Card sx={{ minWidth: 300, borderRadius: '9px', backgroundColor: '#e3f2fd' }}>
      <CardContent>
        <Box display="flex" alignItems="center" gap={1}>
          <PeopleIcon color="primary" />
          <Typography variant="subtitle2" color="text.secondary">
            Real-time Users
          </Typography>
        </Box>
        <Typography variant="h4" fontWeight={600} mt={1}>
          {count !== null ? count : <CircularProgress size={20} />}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          users online now
        </Typography>
      </CardContent>
    </Card>
  );
};

export default RealtimeUsersCard;
